const leadFormType = {
  contact: "contact",
  lead: "lead",
  bookService: "bookService",
};

export default leadFormType;
